import "./App.scss";
import Intro from "./components/Intro";
import Card from "./components/Card";
import TechStack from "./components/TechStack";

function App() {
  return (
    <>
      <div className="app__intro">
        <Intro />
      </div>
      <TechStack />
      <div className="app__experience">
        <div className="app__card-grid">
          <Card
            tenure={"March 2024 - Current"}
            positon={"Product Developer at AND Digital"}
            description={
              "Currently working as a Product Developer at AND Digital, within our clients development teams across multiple tech stacks, closing the digital skills gap"
            }
            link="/experience/and-digital"
          />
          <Card
            tenure={"Side Project - 2025"}
            positon={"Subwise Mobile App (EmberLabs)"}
            description={
              "Personal mobile app project built with React Native, TypeScript, and Expo. Features include local-first architecture, smart analytics for subscription tracking, and freemium monetization with RevenueCat. Developed outside work hours to expand mobile development expertise and explore React Native ecosystem."
            }
            link="/experience/subwise"
          />
          <Card
            tenure={"August 2023 - February 2024"}
            positon={"Front End Engineer at Codeweavers"}
            description={
              "Worked as a Front End Engineer on the Angular Apps that powered the Codeweavers Platform, picked up tickets from various clients to add new functionality as well as fix bugs and run deployments multiple times a day"
            }
            link="/experience/codeweavers"
          />
          <Card
            tenure={"November 2022 - August 2023"}
            positon={"Technical Lead at Vertu Motors"}
            description={
              "During my time at Vertu Motors I became a Technical Lead, in which I led a team through the process of developing a greenfield app from start to finish"
            }
            link="/experience/vertu-motors-tech-lead"
          />
          <Card
            tenure={"October 2021 - August 2023"}
            positon={"Web Developer at Vertu Motors"}
            description={
              "Worked as a Web Developer at Vertu Motors on Angular and React apps that built the 14 websites under the Vertu Motors brand as well as bespoke apps powering their internal processes"
            }
            link="/experience/vertu-motors-web-dev"
          />
          <Card
            tenure={"April 2020 - September 2021"}
            positon={"Web Developer at AME"}
            description={
              "Worked within a WordPress CMS creating a bespoke system for students in Medical School to sign up and take online mock exams and watch courses related to their field of expertise"
            }
            link="/experience/ame"
          />
        </div>
      </div>
    </>
  );
}

export default App;
